
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../dashboard/components/Navbar';
import BottomNav from '../dashboard/components/BottomNav';

export default function Transfer() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    senderName: '',
    senderPhone: '',
    receiverName: '',
    receiverPhone: '',
    receiverCountry: '',
    amount: '',
    currency: 'USD',
    purpose: ''
  });

  const [exchangeRate] = useState(3.75); // سعر صرف تجريبي
  const [commission] = useState(2.5); // عمولة بالنسبة المئوية

  const countries = [
    'الإمارات العربية المتحدة',
    'المملكة العربية السعودية',
    'الكويت',
    'قطر',
    'البحرين',
    'عمان',
    'الأردن',
    'لبنان',
    'مصر',
    'المغرب'
  ];

  const currencies = ['USD', 'EUR', 'SAR', 'AED', 'KWD', 'QAR'];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const calculateTotal = () => {
    const amount = parseFloat(formData.amount) || 0;
    const commissionAmount = (amount * commission) / 100;
    const totalAmount = amount + commissionAmount;
    const receivedAmount = amount * exchangeRate;
    
    return {
      amount,
      commissionAmount,
      totalAmount,
      receivedAmount
    };
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // محاكاة إرسال التحويل
    alert('تم إرسال طلب التحويل بنجاح! سيتم مراجعته خلال 24 ساعة.');
    navigate('/dashboard');
  };

  const { amount, commissionAmount, totalAmount, receivedAmount } = calculateTotal();

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <Navbar />
      
      <div className="pt-20 pb-20 px-4">
        <div className="max-w-md mx-auto">
          {/* العنوان */}
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">تحويل جديد</h1>
            <p className="text-gray-600 mt-2">أدخل بيانات التحويل المطلوبة</p>
          </div>

          {/* نموذج التحويل */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* بيانات المرسل */}
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <i className="ri-user-line ml-2 text-blue-600"></i>
                بيانات المرسل
              </h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">اسم المرسل</label>
                  <input
                    type="text"
                    name="senderName"
                    value={formData.senderName}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="أدخل اسم المرسل"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">رقم الهاتف</label>
                  <input
                    type="tel"
                    name="senderPhone"
                    value={formData.senderPhone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="أدخل رقم الهاتف"
                    required
                  />
                </div>
              </div>
            </div>

            {/* بيانات المستلم */}
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <i className="ri-user-received-line ml-2 text-green-600"></i>
                بيانات المستلم
              </h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">اسم المستلم</label>
                  <input
                    type="text"
                    name="receiverName"
                    value={formData.receiverName}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="أدخل اسم المستلم"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">رقم الهاتف</label>
                  <input
                    type="tel"
                    name="receiverPhone"
                    value={formData.receiverPhone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="أدخل رقم الهاتف"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">الدولة</label>
                  <select
                    name="receiverCountry"
                    value={formData.receiverCountry}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    required
                  >
                    <option value="">اختر الدولة</option>
                    {countries.map((country) => (
                      <option key={country} value={country}>{country}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* بيانات التحويل */}
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <i className="ri-money-dollar-circle-line ml-2 text-blue-600"></i>
                بيانات التحويل
              </h3>
              
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">المبلغ</label>
                    <input
                      type="number"
                      name="amount"
                      value={formData.amount}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0.00"
                      min="1"
                      step="0.01"
                      required
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">العملة</label>
                    <select
                      name="currency"
                      value={formData.currency}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                      {currencies.map((currency) => (
                        <option key={currency} value={currency}>{currency}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">الغرض من التحويل</label>
                  <input
                    type="text"
                    name="purpose"
                    value={formData.purpose}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="مثال: دعم عائلي، رواتب، تجارة"
                    required
                  />
                </div>
              </div>
            </div>

            {/* ملخص التكاليف */}
            {amount > 0 && (
              <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                <h3 className="text-lg font-semibold text-blue-800 mb-4">ملخص التكاليف</h3>
                
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-600">المبلغ المرسل:</span>
                    <span className="font-medium">{amount.toFixed(2)} {formData.currency}</span>
                  </div>
                  
                  <div className="flex justify-between">
                    <span className="text-gray-600">العمولة ({commission}%):</span>
                    <span className="font-medium">{commissionAmount.toFixed(2)} {formData.currency}</span>
                  </div>
                  
                  <div className="border-t border-blue-200 pt-3">
                    <div className="flex justify-between">
                      <span className="font-semibold text-blue-800">إجمالي المبلغ:</span>
                      <span className="font-bold text-blue-800">{totalAmount.toFixed(2)} {formData.currency}</span>
                    </div>
                  </div>
                  
                  <div className="bg-green-100 rounded-lg p-3 mt-4">
                    <div className="flex justify-between">
                      <span className="text-green-700">المبلغ المستلم:</span>
                      <span className="font-bold text-green-700">{receivedAmount.toFixed(2)} AED</span>
                    </div>
                    <p className="text-xs text-green-600 mt-1">سعر الصرف: 1 {formData.currency} = {exchangeRate} AED</p>
                  </div>
                </div>
              </div>
            )}

            {/* أزرار التحكم */}
            <div className="flex gap-4">
              <button
                type="button"
                onClick={() => navigate('/dashboard')}
                className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-300 transition-colors"
              >
                إلغاء
              </button>
              
              <button
                type="submit"
                className="flex-1 bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors"
              >
                إرسال التحويل
              </button>
            </div>
          </form>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
